// ============================================================================
// kezdolapView.js — a TAGOK KEZDŐLAPJA (2026-10-25, a titkár #86 / #92 javaslata): önálló, teljes képernyős réteg a <body>-n (mint a
// cetliView.js): a chat újrarajzolásai nem zavarják, és a render-gyorsítótárhoz nem kell hozzányúlni.
//
// Tartalom: üdvözlés; "Fontos közlemények" (a még tudomásul nem vettek, itt is tudomásul vehetők - ugyanaz a v150-es közlemény, nem
// kell kétszer elolvasni); "Hasznos tudnivalók" (az admin által kijelölt szobák gombjai); két nagy gomb: "Tovább az egyes menükhöz" és
// "Visszatérés az előzőleg megtekintett helyre". A szöveg MINDIG textContent (soha nem innerHTML). Nincs animáció, a gombok azonnal
// használhatók (a titkár: ne kelljen megvárni semmit).
// ============================================================================

import { t, localeFor } from "./i18n.js";
import { feladoNev } from "./chatView.js";
import { getRoomDisplayName } from "./roomName.js";
import { log } from "./log.js";

function datum(ms, uiLang) {
  if (!ms) return "";
  try {
    return new Date(ms).toLocaleString(localeFor(uiLang), { dateStyle: "short", timeStyle: "short" });
  } catch (e) {
    return "";
  }
}

function elem(tag, osztaly, szoveg) {
  const n = document.createElement(tag);
  if (osztaly) n.className = osztaly;
  if (szoveg !== undefined) n.textContent = szoveg;
  return n;
}

let kezdolap = null;

export function kezdolapNyitva() {
  return kezdolap !== null;
}

export function zarjBeKezdolapot() {
  if (kezdolap) kezdolap.bezar();
  elrejtKezdolapSavot();
}

// ---------------------------------------------------------------------------
// A BELÉPÉSI CÉL SÁVJA (v153, a titkár #94 kérése): ha a kezdőlap helyett az admin által kijelölt szoba / téma nyílt meg, felül egy vékony
// sáv két gombbal: "Tovább az egyes menükhöz" és (ha volt előző hely) "Visszatérés az előzőleg megtekintett helyre". Bármelyik gomb
// (vagy a bezárás) eltünteti a sávot. Önálló réteg, nincs animáció.
// ---------------------------------------------------------------------------
let kezdolapSav = null;

export function kezdolapSavVan() {
  return kezdolapSav !== null;
}

export function elrejtKezdolapSavot() {
  if (kezdolapSav) { kezdolapSav.remove(); kezdolapSav = null; }
}

/**
 * @param {{uiLang: string, vanElozoHely: boolean, menuGomb?: boolean, onMenuk: Function, onVissza: Function}} p
 * menuGomb === false (v173): a belépési cél TÉMÁJÁBAN a hirdetmény fejléce már tartalmazza a "Tovább az egyes menükhöz" gombot, ezért a sávban
 * nem ismételjük meg; ha így sem marad gomb (nincs előző hely), a sáv meg sem jelenik.
 */
export function mutassKezdolapSavot(p) {
  elrejtKezdolapSavot();
  const menuGomb = p.menuGomb !== false;
  if (!menuGomb && !p.vanElozoHely) return;
  const sav = elem("div", "kezdolap-sav");
  sav.setAttribute("role", "region");
  if (menuGomb) {
    const menuk = elem("button", "primary-btn compact kezdolap-sav-menuk", t(p.uiLang, "home.toMenus"));
    menuk.type = "button";
    menuk.addEventListener("click", () => { elrejtKezdolapSavot(); p.onMenuk(); });
    sav.appendChild(menuk);
  }
  if (p.vanElozoHely) {
    const vissza = elem("button", "neutral-btn compact kezdolap-sav-vissza", t(p.uiLang, "home.backToPlace"));
    vissza.type = "button";
    vissza.addEventListener("click", () => { elrejtKezdolapSavot(); p.onVissza(); });
    sav.appendChild(vissza);
  }
  const x = elem("button", "text-btn kezdolap-sav-x", "×");
  x.type = "button";
  x.setAttribute("aria-label", t(p.uiLang, "search.close"));
  x.addEventListener("click", elrejtKezdolapSavot);
  sav.appendChild(x);
  document.body.appendChild(sav);
  kezdolapSav = sav;
}

/**
 * Megnyitja a kezdőlapot, vagy - ha már nyitva van - frissíti (új közlemény érkezett / tudomásul vettek egyet / megjött a beállítás).
 * @param {object} p
 *   { uiLang, tartalomNyelv, nev, kozlemenyek (a még tudomásul nem vettek), szobak (a kijelölt, elérhető szobák),
 *     vanElozoHely (bool),
 *     onTudomas(annId): Promise, onSzoba(roomId), onMenuk(), onVissza(), onBezar() }
 */
export function nyissKezdolapot(p) {
  if (kezdolap) {
    kezdolap.frissit(p);
    return kezdolap;
  }
  const gyoker = elem("div", "kezdolap-hatter");
  gyoker.setAttribute("role", "dialog");
  const lap = elem("div", "kezdolap-lap");
  gyoker.appendChild(lap);
  let allapot = { ...p, foglalt: new Set(), hiba: null };

  function rajzol() {
    const { uiLang, tartalomNyelv, kozlemenyek, szobak } = allapot;
    lap.textContent = "";
    const fej = elem("div", "kezdolap-fej");
    fej.appendChild(elem("h2", "kezdolap-cim", "🏠 " + t(uiLang, "home.title")));
    const bezar = elem("button", "kezdolap-bezar text-btn", t(uiLang, "search.close"));
    bezar.type = "button";
    bezar.addEventListener("click", () => allapot.onBezar && allapot.onBezar());
    fej.appendChild(bezar);
    lap.appendChild(fej);
    if (allapot.nev) lap.appendChild(elem("p", "kezdolap-udv", t(uiLang, "home.welcome", { name: allapot.nev })));
    if (allapot.adminFigyelmeztetes) lap.appendChild(elem("div", "cetli-hiba kezdolap-figyelmeztetes kezdolap-admin-figyelmeztetes", t(uiLang, allapot.adminFigyelmeztetes)));
    if (allapot.figyelmeztetes) lap.appendChild(elem("div", "cetli-hiba kezdolap-figyelmeztetes", t(uiLang, allapot.figyelmeztetes)));

    // --- Fontos közlemények
    const szekcio = elem("section", "kezdolap-szekcio");
    szekcio.appendChild(elem("h3", "", "📌 " + t(uiLang, "home.announcements")));
    if (!kozlemenyek || kozlemenyek.length === 0) {
      szekcio.appendChild(elem("p", "hint", t(uiLang, "home.noAnnouncements")));
    } else {
      for (const k of kozlemenyek) {
        const kartya = elem("div", "kezdolap-kozlemeny");
        kartya.appendChild(elem("div", "cetli-meta", [t(uiLang, "ann.from", { name: feladoNev(k, tartalomNyelv, uiLang) }), datum(k.createdAt, uiLang)].filter(Boolean).join(" · ")));
        const fordit = Boolean(k.translatedText);
        const szoveg = elem("div", "cetli-szoveg", fordit ? k.translatedText : k.text);
        const nyelv = fordit ? k.translatedLang : k.sourceLang;
        if (nyelv) szoveg.setAttribute("lang", nyelv);
        kartya.appendChild(szoveg);
        if (fordit) {
          const eredeti = elem("details", "kezdolap-eredeti");
          eredeti.appendChild(elem("summary", "", t(uiLang, "message.showOriginal")));
          const e = elem("div", "cetli-szoveg", k.text);
          if (k.sourceLang) e.setAttribute("lang", k.sourceLang);
          eredeti.appendChild(e);
          kartya.appendChild(eredeti);
        }
        const gomb = elem("button", "primary-btn compact kezdolap-tudomas", t(uiLang, "ann.ack"));
        gomb.type = "button";
        gomb.disabled = allapot.foglalt.has(k.annId);
        gomb.addEventListener("click", async () => {
          if (allapot.foglalt.has(k.annId)) return;
          allapot.foglalt.add(k.annId);
          allapot.hiba = null;
          rajzol();
          try {
            await allapot.onTudomas(k.annId);
            allapot.kozlemenyek = (allapot.kozlemenyek || []).filter((x) => x.annId !== k.annId);
          } catch (err) {
            log.error("[kezdőlap] a tudomásul vétel nem sikerült:", err);
            allapot.hiba = t(uiLang, "ann.ackFailed");
          } finally {
            allapot.foglalt.delete(k.annId);
            rajzol();
          }
        });
        kartya.appendChild(gomb);
        szekcio.appendChild(kartya);
      }
    }
    if (allapot.hiba) szekcio.appendChild(elem("div", "cetli-hiba", allapot.hiba));
    lap.appendChild(szekcio);

    // --- Következő ügyem (v221, a titkár #65 javaslata): az olvasatlan szobák (legfeljebb 5), egy koppintással megnyithatók.
    if (Array.isArray(allapot.olvasatlan)) {
      const kov = elem("section", "kezdolap-szekcio kezdolap-kovetkezo");
      kov.appendChild(elem("h3", "", "➡ " + t(uiLang, "home.nextTitle")));
      if (allapot.olvasatlan.length === 0) {
        kov.appendChild(elem("p", "hint", t(uiLang, "home.nextNone")));
      } else {
        kov.appendChild(elem("p", "hint", t(uiLang, "home.nextUnread")));
        for (const r of allapot.olvasatlan.slice(0, 5)) {
          const gomb = elem("button", "list-item kezdolap-szoba kezdolap-olvasatlan", "● " + getRoomDisplayName(r, tartalomNyelv, uiLang));
          gomb.type = "button";
          gomb.dataset.roomId = r.roomId;
          gomb.addEventListener("click", () => allapot.onSzoba && allapot.onSzoba(r.roomId));
          kov.appendChild(gomb);
        }
        if (allapot.olvasatlan.length > 5) kov.appendChild(elem("p", "hint", t(uiLang, "home.nextMore", { n: allapot.olvasatlan.length - 5 })));
      }
      lap.appendChild(kov);
    }

    // --- Hasznos tudnivalók: az admin által kijelölt szobák (csak az elérhetők)
    if (szobak && szobak.length > 0) {
      const tud = elem("section", "kezdolap-szekcio");
      tud.appendChild(elem("h3", "", "📘 " + t(uiLang, "home.links")));
      for (const r of szobak) {
        const gomb = elem("button", "list-item kezdolap-szoba", getRoomDisplayName(r, tartalomNyelv, uiLang));
        gomb.type = "button";
        gomb.dataset.roomId = r.roomId;
        gomb.addEventListener("click", () => allapot.onSzoba && allapot.onSzoba(r.roomId));
        tud.appendChild(gomb);
      }
      lap.appendChild(tud);
    }

    // --- A két nagy gomb
    const nagy = elem("div", "kezdolap-nagy");
    const menuk = elem("button", "primary-btn kezdolap-menuk", t(uiLang, "home.toMenus"));
    menuk.type = "button";
    menuk.addEventListener("click", () => allapot.onMenuk && allapot.onMenuk());
    nagy.appendChild(menuk);
    if (allapot.vanElozoHely) {
      const vissza = elem("button", "neutral-btn kezdolap-vissza", t(uiLang, "home.backToPlace"));
      vissza.type = "button";
      vissza.addEventListener("click", () => allapot.onVissza && allapot.onVissza());
      nagy.appendChild(vissza);
    }
    lap.appendChild(nagy);
  }

  function frissit(uj) {
    allapot = { ...allapot, ...uj, foglalt: allapot.foglalt, hiba: null };
    rajzol();
  }

  function bezar() {
    document.removeEventListener("keydown", billentyu);
    gyoker.remove();
    if (kezdolap && kezdolap.gyoker === gyoker) kezdolap = null;
  }
  function billentyu(e) { if (e.key === "Escape" && allapot.onBezar) allapot.onBezar(); }
  document.addEventListener("keydown", billentyu);

  document.body.appendChild(gyoker);
  kezdolap = { gyoker, bezar, frissit };
  rajzol();
  return kezdolap;
}
